/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RetrieveSixbidLotIds$Params {
  auctionCatalogPartId: number;
  'X-API-Version'?: string;
}

export function retrieveSixbidLotIds(http: HttpClient, rootUrl: string, params: RetrieveSixbidLotIds$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, retrieveSixbidLotIds.PATH, 'get');
  if (params) {
    rb.path('auctionCatalogPartId', params.auctionCatalogPartId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

retrieveSixbidLotIds.PATH = '/api/admin/retrievelotids/{auctionCatalogPartId}';
